module.exports = __webpack_public_path__ + "img/MoMobil5.83cfe2a5.png";